export default __webpack_public_path__ + "static/media/22_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A2926.22610bce.jpg";